import axios from "axios";
import router from "../router";
import { BreedingRhombusSpinner } from "epic-spinners";

export default {
  namespaced: true,
  state: {
    allProjects: [],
    actualProject: [],
    firstProject: [],
    projectDetail: null,
    //RightMenues:
    showRightMenu: false, // right menu closed
    isEditing: false, // watches if we are on editing mode on right menu
    // end RightMenues

    //notifications:
    myNotifications: [],
    newNotifications: 0,
  },
  mutations: {
    setIsEditing(state, bool) {
      state.isEditing = bool;
    },
    //RightMenues:
    openRightMenuMutation(state) {
      state.showRightMenu = true;
    },
    closeRightMenuMutation(state) {
      state.showRightMenu = false
      state.isEditing = false
    },
    // end RightMenues

    changeAlertModal(state, err) {
      state.alertModal.active = true;
      state.alertModal.err = err.response.data.result[0].msg; // en users y clients el error trae un mensaje
    },

    /** NOTIFICATIONS: */
    setNotifications(state, data) {
      data.reverse();
      state.myNotifications = data;
    },
    countNewNotifications(state, data) {
      let countNew = 0;
      data.forEach(element => {
        if (element.status == 0) {
          countNew++;
        }
      });
      state.newNotifications = countNew;
    },
    setProjects(state, data) {
      state.allProjects = data;      
    },
    setActualProject(state, data){
      state.actualProject = data;      
      localStorage.setItem("projectId", data.id);
      localStorage.setItem("projectName", data.name);  
    },
    setFirstProject(state, data){      
      state.firstProject = data;      
    },
    setProjectDetail(state, data){
      state.projectDetail = data;
    }
  },
  actions: {
    /** NOTIFICATIONS: */

    // GET all my notifications
    async getMyNotifications({ commit }) {
      try {
        let response = await axios.get("/Anotifications/me");
        let result = response.data;
        commit("setNotifications", response.data);
        commit("countNewNotifications", response.data);
      } catch (err) {
        console.log(err.response.data);
        commit("changeAlertModal", err.response.data.result);  
      }
    },

    //notifications were read
    cleanNewNotifications({ commit, dispatch }, id) {
      let data = {};
      data.recieved = true;
      axios
        .put(`/Anotifications/${id}`, data)
        .then(response => {
          dispatch("getMyNotifications");
        })
        .catch(err => {
          commit("changeAlertModal", err.response.data.result[0]);
        });
    },

    /** CLIENTS: */

    // PUT Client
    putClientStore({ commit, dispatch }, form_data) {
      console.log("data::::");
      console.log(form_data);
      let id = "";
      for (var pair of form_data.entries()) {
        console.log(pair[0] + ", " + pair[1]);
        if (pair[0] == "idClient") {
          id = pair[1];
        }
      }
      axios
        .put(`/Aclients/${id}`, form_data)
        .then(response => {
          commit("closeRightMenuMutation");
          dispatch("getAllClients");
        })
        .catch(err => {
          commit("changeAlertModal", err.response.data.result[0]);
        });
    },

    // DELETE one or more clients
    deleteSelectedClientsStore({ commit, dispatch }, data) {
      let idsArr = [];
      data.forEach(data => {
        idsArr.push(data.idClient);
      });
      axios
        .delete("/Aclients", {
          data: {
            ids: idsArr
          }
        })
        .then(response => {
          dispatch("getAllClients");
          commit("setClientDetails", []);
        })
        .catch(err => {
          console.log(err.response.data);
          commit("changeAlertModal", err.response.data.result[0]);
        });
    },
    async getProjects({ commit }) {
      try {
        let response = await axios.get("/projects");
        let result = response.data;    
              
        commit("setProjects", result);
        // commit("countNewNotifications", response.data);
      } catch (err) {
        console.log(err.response.data);
      }
    },
    async getProjectDetail({ commit }, idProject) {
      try {
        let response = await axios.get(`/Aproject/${idProject}`);
        if (response.data && response.data.length > 0) {
          commit("setProjectDetail", response.data[0]);
        }
      } catch (err) {
        console.log("Error fetching project detail:", err);
      }
    }
    
  },
  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/app.js